import { render } from "./Splash.vue?vue&type=template&id=2f474517&scoped=true"
import script from "./Splash.vue?vue&type=script&setup=true&lang=js"
export * from "./Splash.vue?vue&type=script&setup=true&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=2f474517&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.22_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f474517"],['__file',"src/components/Splash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f474517"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f474517', __exports__)) {
    api.reload('2f474517', __exports__)
  }
  
  module.hot.accept("./Splash.vue?vue&type=template&id=2f474517&scoped=true", () => {
    api.rerender('2f474517', render)
  })

}


export default __exports__